import { State } from '@progress/kendo-data-query';
import { Pager } from '@progress/kendo-react-data-tools';
import { Grid, GridCellProps, GridColumn, GridFilterChangeEvent } from '@progress/kendo-react-grid';
import React, { useState, useEffect } from 'react';
import { HistoryGridWrapper } from '../styles/HistoryGrid.styled';
import { historyGridColumns } from './HistoryGridColumns';
import { process as kendoProcess } from '@progress/kendo-data-query';
import { isColumnActive } from '@/common/gridHelpers';
import GridCellDate from '@/components/message-center/GridCellDate';
import GridCellHtml from './GridCellHtml';
import GridCellAction from './GridCellAction';
import { ChangeHistoryItem } from '@/api/client';

interface IProps {
  messageHistory: ChangeHistoryItem[] | undefined;
}

const HistoryGrid: React.FC<IProps> = ({ messageHistory }) => {
  //const messageHistory = messageHistory;
  const [gridDataState, setGridDataState] = useState<State>({ skip: 0, take: 10 });
  const [resultWithoutPagination, setResultWithoutPagination] = useState<any[]>();
  const [result, setResult] = useState<any[]>();

  useEffect(() => {
    let resultWithoutPag = [];
    if (messageHistory?.length) {
      resultWithoutPag = kendoProcess(messageHistory, {
        ...gridDataState,
        skip: undefined,
        take: undefined,
      }).data;
      setResultWithoutPagination(resultWithoutPag);
    }
    if (resultWithoutPag?.length)
      setResult(kendoProcess(resultWithoutPag, { skip: gridDataState.skip, take: gridDataState.take }).data);
  }, [messageHistory, gridDataState]);

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    const newFilter = e.filter;
    setGridDataState({ ...gridDataState, filter: newFilter });
  };

  const getColumnCell = (column: typeof GridColumn) => {
    if (column.filter === 'date') {
      // eslint-disable-next-line react/prop-types
      return (props: GridCellProps) => GridCellDate({ date: props.dataItem[column.field], includeTimeStamp: true });
    } else if (column.field === 'newValue' || column.field === 'previousValue') {
      // eslint-disable-next-line react/prop-types
      return (props: GridCellProps) => GridCellHtml({ html: props.dataItem[column.field] });
    } else if (column.field === 'action') {
      // eslint-disable-next-line react/prop-types
      return (props: GridCellProps) => GridCellAction({ action: props.dataItem[column.field] });
    } else {
      return null;
    }
  };

  return (
    <HistoryGridWrapper id="grdHistory">
      <Grid
        data={result}
        className="ml__kendo-grid"
        reorderable
        resizable
        pageable
        pager={() => (
          <Pager
            skip={gridDataState.skip!}
            take={gridDataState.take!}
            pageSizes={[10, 20, 50, 100, 200, 500, 1000]}
            buttonCount={3}
            previousNext
            onPageChange={(e) => setGridDataState({ ...e })}
            total={resultWithoutPagination?.length ?? 0}
          />
        )}
        {...gridDataState}
        onFilterChange={handleFilterChange}
        skip={gridDataState.skip}
        take={gridDataState.take}
        onDataStateChange={(e) => setGridDataState(e.dataState)}
      >
        {historyGridColumns.map((column) => (
          <GridColumn
            id={`lbl${column.title.replace(/ /g, '')}`}
            minResizableWidth={100}
            key={column.field}
            field={column.field}
            title={column.title}
            width={column.width}
            show={column.show}
            filter={column.filter}
            headerClassName={isColumnActive(column.field, gridDataState) ? 'active' : ''}
            cell={getColumnCell(column)}
          />
        ))}
      </Grid>
    </HistoryGridWrapper>
  );
};

export default HistoryGrid;
